<template>
  <el-dialog :visible.sync="visible" title="修改告警设置" width="650px" custom-class="alarm-dialog" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="alarm-form">
      <el-form-item label="小区" prop="communityName">
        <el-input v-model="form.communityName" disabled />
      </el-form-item>
      <el-form-item label="告警类型" prop="alarmTypeName">
        <el-input v-model="form.alarmTypeName" disabled />
      </el-form-item>
      <el-form-item label="告警级别" prop="alarmLevel">
        <el-select v-model="form.alarmLevel" placeholder="请选择告警级别" style="width:100%">
          <el-option label="高" value="HIGH" />
          <el-option label="中" value="MEDIUM" />
          <el-option label="低" value="LOW" />
        </el-select>
      </el-form-item>
      <el-form-item label="默认处理人" prop="defaultHandlerNames">
        <div class="alarm-picker">
          <el-input :value="selectedStaffNames" readonly placeholder="请选择（选填）" class="alarm-input" @focus="openStaffDialog" />
          <el-button class="alarm-pick-btn" @click="openStaffDialog">选择</el-button>
        </div>
      </el-form-item>
      <el-form-item label="办理时长" prop="handleTime">
        <el-autocomplete
          v-model="handleTimeDisplay"
          :fetch-suggestions="getHandleTimeSuggestions"
          placeholder="请输入"
          style="width:100%"
          value-key="label"
          @select="handleSelectTime"
        >
          <template slot="append">分钟</template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="超时预警" prop="overtimeWarning">
        <el-input v-model.number="form.overtimeWarning" placeholder="请输入" style="width:100%">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="回访设置" prop="returnVisitFlag">
        <el-select v-model="form.returnVisitFlag" placeholder="请选择" style="width:100%">
          <el-option label="需要回访" value="Y" />
          <el-option label="不需要回访" value="N" />
        </el-select>
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="alarm-btn-cancel" @click="visible = false">取消</el-button>
      <el-button class="alarm-btn-confirm" type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
    </span>

    <!-- 选人弹窗 -->
    <el-dialog :visible.sync="staffDialogVisible" title="选择处理人员" width="760px" custom-class="alarm-staff-dialog" append-to-body @open="syncStaffSelection">
      <div class="staff-toolbar">
        <el-input v-model="staffKeyword" clearable size="small" placeholder="请输入姓名或ID" class="staff-search" />
      </div>
      <el-table ref="staffTable" v-loading="staffLoading" :data="filteredStaffOptions" row-key="userId" style="width: 100%" max-height="400" @selection-change="handleStaffSelectionChange">
        <el-table-column type="selection" width="52" />
        <el-table-column prop="userId" label="员工ID" min-width="150" show-overflow-tooltip />
        <el-table-column label="姓名" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.userName || scope.row.name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="tel" label="手机号" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.tel || '-' }}</template>
        </el-table-column>
        <el-table-column prop="orgName" label="组织" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orgName || '-' }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="alarm-btn-cancel" @click="staffDialogVisible = false">取消</el-button>
        <el-button class="alarm-btn-confirm" type="primary" @click="confirmStaffSelection">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getStaffInfos } from '@/api/work/repairTypeUserApi'
import { updateAlarmSetting } from '@/api/inspection/alarmSettingManageApi'
import { listAlarmHandlers } from '@/api/inspection/alarmSettingApi'

export default {
  name: 'EditAlarmSetting',
  data() {
    return {
      visible: false,
      loading: false,
      staffLoading: false,
      staffDialogVisible: false,
      staffKeyword: '',
      form: {
        alarmSettingId: '',
        communityId: '',
        communityName: '',
        alarmTypeCd: '',
        alarmTypeName: '',
        alarmLevel: '',
        defaultHandlerId: [],
        defaultHandlerNames: '',
        handleTime: null,
        overtimeWarning: null,
        returnVisitFlag: 'Y',
        remark: ''
      },
      rules: {
        alarmLevel: [{ required: true, message: '请选择告警级别', trigger: 'change' }],
        handleTime: [{ required: true, message: '请输入办理时长', trigger: 'blur' }],
        returnVisitFlag: [{ required: true, message: '请选择回访设置', trigger: 'change' }]
      },
      staffOptions: [],
      pendingStaffIds: [], // 临时存储选择的人员ID
      isSyncing: false // 标志位：是否正在同步选中状态
    }
  },
  computed: {
    // 根据已选ID计算显示的人员名称
    selectedStaffNames() {
      if (!this.form.defaultHandlerId || this.form.defaultHandlerId.length === 0) {
        return ''
      }
      return this.staffOptions
        .filter(item => this.form.defaultHandlerId.includes(item.userId))
        .map(item => item.userName || item.name || item.userId)
        .join('、')
    },
    // 办理时长的字符串显示（用于 el-autocomplete）
    // 后端存储的是分钟，前端也使用分钟
    handleTimeDisplay: {
      get() {
        if (this.form.handleTime === null || this.form.handleTime === undefined) {
          return ''
        }
        return String(this.form.handleTime)
      },
      set(value) {
        if (!value) {
          this.form.handleTime = null
          return
        }
        this.form.handleTime = Number(value)
      }
    },
    filteredStaffOptions() {
      const keyword = (this.staffKeyword || '').trim()
      if (!keyword) return this.staffOptions
      return this.staffOptions.filter(item => {
        return [item.userId, item.userName, item.name, item.tel, item.orgName]
          .some(value => String(value || '').includes(keyword))
      })
    }
  },
  watch: {
    'form.handleTime'(newVal) {
      // 监听办理时长变化，自动计算超时预警时间
      if (newVal && !isNaN(newVal) && newVal > 0) {
        const handleTimeInMinutes = newVal // 后端已改为分钟，无需转换
        // 根据规则设置预警时间（预警时间点，非剩余时间）
        if (handleTimeInMinutes === 10 || handleTimeInMinutes === 20) {
          this.form.overtimeWarning = 5 // 10分钟和20分钟都是5分钟预警
        } else if (handleTimeInMinutes === 30 || handleTimeInMinutes === 45) {
          this.form.overtimeWarning = 10 // 30分钟和45分钟都是10分钟预警
        } else {
          // 其他自定义时长，使用动态规则
          if (handleTimeInMinutes <= 20) {
            this.form.overtimeWarning = 5
          } else {
            this.form.overtimeWarning = 10
          }
        }
      } else {
        this.form.overtimeWarning = null
      }
    }
  },
  methods: {
    async open(row) {
      this.form = {
        alarmSettingId: row.alarmSettingId,
        communityId: row.communityId,
        communityName: row.communityName,
        alarmTypeCd: row.alarmTypeCd,
        alarmTypeName: row.alarmTypeName,
        alarmLevel: row.alarmLevel,
        defaultHandlerId: [],
        defaultHandlerNames: '',
        handleTime: row.handleTime,
        overtimeWarning: row.overtimeWarning || null,
        returnVisitFlag: row.returnVisitFlag,
        remark: row.remark || ''
      }

      this.visible = true

      // 并行加载：人员列表 + 已绑定的处理人员
      await Promise.all([
        this.loadStaffOptions(),
        this.loadExistingHandlers()
      ])
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.pendingStaffIds = []
      this.staffOptions = []
    },
    async loadStaffOptions() {
      this.staffLoading = true
      try {
        const res = await getStaffInfos({ communityId: this.form.communityId })
        this.staffOptions = Array.isArray(res.staffs) ? res.staffs : (Array.isArray(res) ? res : [])
      } catch (error) {
        this.$message.error(error.message || '获取人员列表失败')
        this.staffOptions = []
      } finally {
        this.staffLoading = false
      }
    },
    async loadExistingHandlers() {
      try {
        const params = {
          page: 1,
          row: 1000,
          communityId: this.form.communityId,
          alarmTypeCd: this.form.alarmTypeCd
        }
        const res = await listAlarmHandlers(params)
        console.log('listAlarmHandlers 返回结果:', res)
        const handlers = res.data || []
        console.log('handlers 数据:', handlers)
        // 提取人员ID列表
        const handlerIds = handlers.map(item => String(item.staffId || item.userId)).filter(Boolean)
        console.log('提取的 handlerIds:', handlerIds, '类型:', handlerIds.map(id => typeof id))
        // 更新表单中的处理人员ID
        this.form.defaultHandlerId = handlerIds
      } catch (error) {
        console.error('获取已绑定处理人员失败:', error)
        this.form.defaultHandlerId = []
      }
    },
    async openStaffDialog() {
      // 如果人员列表为空，先加载数据
      if (!this.staffOptions || this.staffOptions.length === 0) {
        await this.loadStaffOptions()
      }
      this.staffDialogVisible = true
    },
    // 同步选中状态（在对话框打开时触发）
    syncStaffSelection() {
      // 设置同步标志，防止触发 selection-change 事件
      this.isSyncing = true

      // 复制当前已选ID到临时变量
      this.pendingStaffIds = [...(this.form.defaultHandlerId || [])]

      this.$nextTick(() => {
        if (!this.$refs.staffTable) {
          this.isSyncing = false
          return
        }
        // 清空之前的选择状态
        this.$refs.staffTable.clearSelection()
        // 根据已选择的ID回显选中状态
        this.staffOptions.forEach(staff => {
          // 兼容字符串和数字类型比较
          const staffIdStr = String(staff.userId)
          const isMatch = this.pendingStaffIds.some(id => String(id) === staffIdStr)
          if (isMatch) {
            this.$refs.staffTable.toggleRowSelection(staff, true)
          }
        })
        // 同步完成，解除标志
        this.isSyncing = false
      })
    },
    // 监听表格选择变化
    handleStaffSelectionChange(selection) {
      // 如果正在同步选中状态，忽略此事件
      if (this.isSyncing) return
      this.pendingStaffIds = selection.map(item => item.userId)
    },
    confirmStaffSelection() {
      // 将临时选择的ID复制到表单中
      this.form.defaultHandlerId = [...this.pendingStaffIds]
      // defaultHandlerNames 会通过 computed 属性 selectedStaffNames 自动计算
      this.staffDialogVisible = false
    },
    async handleSubmit() {
      if (this.loading) return // 防止重复提交

      this.$refs.form.validate(async valid => {
        if (!valid) return

        if (this.loading) return // 二次检查
        this.loading = true

        try {
          const payload = {
            alarmSettingId: this.form.alarmSettingId,
            alarmLevel: this.form.alarmLevel,
            handleTime: this.form.handleTime,
            returnVisitFlag: this.form.returnVisitFlag
          }
          // 将多个处理人员ID数组转为逗号分隔的字符串
          if (this.form.defaultHandlerId && this.form.defaultHandlerId.length > 0) {
            payload.defaultHandlerId = this.form.defaultHandlerId.join(',')
          }
          if (this.form.overtimeWarning) payload.overtimeWarning = this.form.overtimeWarning
          if (this.form.remark) payload.remark = this.form.remark

          await updateAlarmSetting(payload)
          this.$message.success('修改成功')
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || '修改失败')
        } finally {
          this.loading = false
        }
      })
    },
    getHandleTimeSuggestions(queryString, cb) {
      const suggestions = [
        { label: '10分钟', value: '10' },
        { label: '20分钟', value: '20' },
        { label: '30分钟', value: '30' },
        { label: '45分钟', value: '45' }
      ]
      cb(suggestions)
    },
    handleSelectTime(item) {
      // item.value 是分钟字符串，通过 handleTimeDisplay setter 自动转换为小时
      this.handleTimeDisplay = item.value
    }
  }
}
</script>

<style scoped>
.alarm-form { padding: 8px 24px 0; }
.alarm-form >>> .el-form-item { margin-bottom: 20px; }
.alarm-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; }
.alarm-form >>> .el-input__inner, .alarm-form >>> .el-textarea__inner { border-radius: 8px; border-color: #DCE6F5; }
.alarm-picker { display: flex; gap: 8px; }
.alarm-input { flex: 1; }
.alarm-pick-btn { width: 80px; border-radius: 8px; }
.dialog-footer { display: flex; justify-content: flex-end; gap: 12px; padding: 20px 24px; }
.alarm-btn-cancel, .alarm-btn-confirm { width: 80px; height: 38px; border-radius: 10px; }
.alarm-btn-cancel { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.alarm-btn-confirm { background: #0E76FF; border-color: #0E76FF; }
.staff-toolbar { margin-bottom: 12px; }
.staff-search { width: 220px; }
.alarm-dialog >>> .el-dialog__header { height: 66px; padding: 0 24px; background: #ebf2fa; border-bottom: 1px solid #dce6f5; line-height: 66px; }
.alarm-dialog >>> .el-dialog__title { color: #1d2129; font-size: 16px; font-weight: 600; }
.alarm-staff-dialog >>> .el-dialog__header { height: 66px; padding: 0 24px; background: #ebf2fa; border-bottom: 1px solid #dce6f5; line-height: 66px; }
.alarm-staff-dialog >>> .el-dialog__body { padding: 20px 24px; }
</style>

